
export { getThumbnailsByTag } from "./contentfulAPI/thumbnail.fetchers"
export { tagsAndMarketsQuery } from "./constant"